"use client"
import Link from "next/link";
import React, { useState } from "react";
import { FaRegTrashAlt, FaLinkedin, FaEnvelope, FaPhone, FaBriefcase, FaCalendarAlt } from "react-icons/fa";
import DeleteModal from "./deleteModal";
import { DeleteApplicant } from "@/API/response";
import { useDispatch } from "react-redux";
import { deleteCandidate } from "@/GlobalRedux/GetCareerDetails";
import Image from "next/image";

const ApplicantCards = ({
  applicantName,
  applicantRole,
  previousJob,
  applicantExp,
  applicantEmail,
  applicantPhone,
  id,
  applicantLinkedin,
  applicantDate,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [appID, setAppID] = useState(null);
  const dispatch = useDispatch();

  const openModal = (id) => {
    setAppID(id);
    setIsOpen(true);
  };

  const submitModal = async () => {
    setIsOpen(false);
    try {
      await DeleteApplicant(`/career/delete/${appID}`);
      dispatch(deleteCandidate(appID));
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <div className="group relative w-full max-w-sm bg-[#111827] rounded-2xl border border-gray-800 shadow-xl hover:border-blue-500/50 transition-all duration-300 overflow-hidden">
        
        {/* Subtle Gradient Overlay on Hover */}
        <div className="absolute inset-0 bg-gradient-to-b from-blue-500/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none" />

        {/* Top Action Bar */}
        <div className="flex justify-between items-start p-4 pb-0 relative z-10">
           <span className="px-3 py-1 text-[10px] font-bold uppercase tracking-wider text-blue-400 bg-blue-500/10 rounded-full border border-blue-500/20">
             {applicantExp || "New"} Exp
           </span>
           <button
            onClick={() => openModal(id)}
            className="p-2 text-gray-500 hover:text-red-400 hover:bg-red-400/10 rounded-lg transition-colors"
            title="Delete Applicant"
          >
            <FaRegTrashAlt className="w-4 h-4" />
          </button>
        </div>

        {/* Profile Section */}
        <div className="flex flex-col items-center px-6 pt-2 pb-6 relative z-10">
          <div className="relative w-20 h-20 mb-4">
            {/* Ambient Glow behind avatar */}
            <div className="absolute inset-0 bg-blue-600 rounded-full blur-md opacity-20 group-hover:opacity-40 transition-opacity duration-500"></div>
            <div className="relative w-20 h-20 rounded-full overflow-hidden border-2 border-gray-800 shadow-inner">
              <Image
                src="https://media.istockphoto.com/id/1255163297/vector/user-profile-icon-vector-avatar-portrait-symbol-flat-shape-person-sign-logo-black-silhouette.jpg?s=612x612&w=0&k=20&c=p6azyhUBIcWx6-aXVRPUTveaVqbTA2bNXpBoGQjEB68="
                alt={applicantName}
                fill
                className="object-cover grayscale-[20%] group-hover:grayscale-0 transition-all"
              />
            </div>
          </div>
          
          <h2 className="text-xl font-bold text-gray-100 text-center leading-tight">
            {applicantName}
          </h2>
          <p className="text-sm font-medium text-blue-400 mt-1">{applicantRole}</p>
        </div>

        <div className="mx-5 border-t border-gray-800/60" />

        {/* Info Grid */}
        <div className="p-5 space-y-3 relative z-10">
          <div className="flex items-center text-sm text-gray-400">
            <FaBriefcase className="w-4 h-4 mr-3 text-blue-500/70" />
            <span className="truncate">Prev: <b className="text-gray-200 font-medium">{previousJob || "N/A"}</b></span>
          </div>
          
          <div className="flex items-center text-sm text-gray-400">
            <FaEnvelope className="w-4 h-4 mr-3 text-blue-500/70" />
            <span className="truncate hover:text-gray-200 transition-colors cursor-default">{applicantEmail}</span>
          </div>

          <div className="flex items-center text-sm text-gray-400">
            <FaCalendarAlt className="w-4 h-4 mr-3 text-blue-500/70" />
            <span>Applied: <span className="text-gray-300">{applicantDate}</span></span>
          </div>
        </div>

        {/* Footer Actions */}
        <div className="px-5 pb-5 pt-2 flex gap-2 relative z-10">
          <Link 
            href={applicantLinkedin || "#"} 
            target="_blank"
            className="flex items-center justify-center w-11 h-11 rounded-xl border border-gray-800 text-gray-400 hover:bg-blue-500/10 hover:text-blue-400 hover:border-blue-500/40 transition-all"
          >
            <FaLinkedin className="w-5 h-5" />
          </Link>
          
          <Link href={`/showcareerform/${id}`} className="flex-1">
            <button className="w-full h-11 bg-blue-500 text-white text-sm font-semibold rounded-xl hover:bg-blue-500 transition-all shadow-lg shadow-blue-900/20 active:scale-[0.98]">
              View Details
            </button>
          </Link>
        </div>
      </div>

      <DeleteModal isOpen={isOpen} onClose={() => setIsOpen(false)} onConfirm={submitModal} />
    </>
  );
};

export default ApplicantCards;